import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import OrganizationService from '@forwardflow/services/OrganizationService'
import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

interface UseGetOrganizationListParams extends PaginationQueryParams {
   shouldFetch?: boolean
}

export const useGetOrganizationList = ({
   shouldFetch = true,
   ...queryParams
}: UseGetOrganizationListParams) => {
   const response = useSWR(
      shouldFetch ? [QUERY_KEYS.ORGANIZATION_LIST, { ...queryParams }] : null,
      () => OrganizationService.getOrganization(queryParams),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
   }
}
